export class PagedResult<T> {
     Results: T[];
     TotalRecords: number;
}
